export function isTruthy(x) {
    return !!x;
}
